/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: Dashboard
 * (C) Copyright IBM Corp. 2023, 2025
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 */
define([
], (
) => {

	const INITIAL_COLUMN_INDEX = -1;
	const INITIAL_ROW_INDEX = -1;
	const DASHBOARD_GRID_CELL = 'dashboard-grid-cell';
	const DASHBOARD_CELL_IS_FOCUSED = 'dashboard-grid-cell-is-focused';

	const getInitialSelectedCell = () => {
		return {
			columnIndex: INITIAL_COLUMN_INDEX,
			rowIndex: INITIAL_ROW_INDEX
		};
	};

	/**
	 * This class is responsible for rendering the outline border for a selected cell in a grid for table and cross tab
	 */
	return class GridCellSelection {
		constructor ({ domNode }) {
			this.domNode = domNode;
			this.selectedCell = getInitialSelectedCell();
			document.addEventListener('mouseup', this._onMouseUpTouchEndHandler.bind(this));
			document.addEventListener('touchend', this._onMouseUpTouchEndHandler.bind(this));
		}

		remove () {
			document.removeEventListener('mouseup', this._onMouseUpTouchEndHandler.bind(this));
			document.removeEventListener('touchend', this._onMouseUpTouchEndHandler.bind(this));
		}

		/**
		 * Set selected cell
		 */
		setSelectedCell (selectedCell) {
			this.selectedCell = selectedCell || getInitialSelectedCell();
		}

		addCellIsFocusedClass({ gridCellProps, classList }) {
			const selectedCell = this._getSelectedCell();
			const cellIsFocus = selectedCell.columnIndex === gridCellProps.col && selectedCell.rowIndex === gridCellProps.row;
			if (cellIsFocus) {
				classList.push(DASHBOARD_CELL_IS_FOCUSED);
			}
		}

		/**
		 * Return the current selected cell
		 */
		_getSelectedCell () {
			return this.selectedCell;
		}

		/**
		 * Handle mouse up and touchend events
		 */
		_onMouseUpTouchEndHandler(event = {}) {
			const target = event.target;
			if (target && !target.classList.contains(DASHBOARD_GRID_CELL)) {
				const node = this.domNode.querySelector(`.${DASHBOARD_CELL_IS_FOCUSED}`);
				node && node.classList.remove(DASHBOARD_CELL_IS_FOCUSED);
				// Reset to not selected
				this.selectedCell = getInitialSelectedCell();
			}
		}
	};
});
